const swissAmount = new Intl.NumberFormat('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Which apostrophe de-CH groups with depends on the ICU build. Node still emits U+0027, browsers emit U+2019. Pinned
// to the browser's so the amount a test asserts is the one a partner is shown.
const GROUPING_APOSTROPHE = '’';

export function formatSwissAmount(amount: string): string {
    return swissAmount
        .format(Number(amount))
        .replace(/['’]/g, GROUPING_APOSTROPHE)
        .replace(/\.00$/, '.–');
}
